// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/Fonts/N27-RegularItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/Fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/Images/frame1-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/Images/buttonbg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/Images/frame2-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAzQAAAOFCAYAAAC85KenAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABPMSURBVHgB7dvBbd1GFEDRmYDaeyFqm6SDlKBU4nSSGtyB00E6sEpwB7b3FOC9gE/THXzv5gLnAIPXAi/e4xyLeHf5OQYAAMCdtrGIbdv+mnN+GgAAAHf6bQAAAEQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkbfu+/zMWMOf8/TzPAQAAcK95Bc0qFfH5eh/GGp6v934AAABL28Yiru3M9+M4Po4FXJH3cwgaAABYnH9oAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgKzt7e3tz7GAh4eH56enpy9jAbfb7d2ccwAAAGtb5qv98fHx+YqITwMAAOBOTs4AAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACArLnv+zkAAACCbGgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAAZAlaABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AwAAKBK0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACytgEAAPBrPp7n+W0sQNAAAAC/5IqZ/47jeBkLcHIGAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZM19388BAACs7sN5nv+PBcw531/jj7GAbQAAAMu73W6fX19fX8YCrqXIv9d4HgtwcgYAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkzX3fzwEAAHCn8zz/Po7jZSzAhgYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADIEjQAAECWoAEAALIEDQAAkCVoAACALEEDAABkCRoAACBL0AAAAFmCBgAAyBI0AABAlqABAACyBA0AAJAlaAAAgCxBAwAAZAkaAAAgS9AAAABZggYAAMgSNAAAQJagAQAAsgQNAACQJWgAAIAsQQMAAGQJGgAAIEvQAAAAWYIGAADI2q73dQAAAAT9AHKCRCb2QMRCAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYsAAABMCAYAAACcepszAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHdSURBVHgB7dyxbeMwGIZh8iD3btRf7eYygr1BSpc3lPt4k1gbOBtkABcZwICOuKSL5K8PnwcgCPiH6hemBNZtMwzDU1lwv9+vH00BoGvDZrN5bvvL4nAYDm27FAC69qsAQCAWAERiAUAkFgBEYgFAVMdxfJrn+XlpOE3Tn91uty0A9OxaH01bRF7bti8A9OziGAqASCwAiMQCgEgsAIjEAoBoGMfxb1m5SLDNDrfb7bA0m5sCQBf8swAgEgsAIrEAIBILACKxACAa5nl+b+u8NDydTvvj8fi7ANA1FwkCkLhIEIBMLACIxAKASCwAiMQCgEgsAIjEAoBILACIxAKASCwAiMQCgEgsAIjEAoBILACIxAKASCwAiMQCgEgsAIjEAoBILACIxAKASCwAiMQCgEgsAIjEAoBILACIxAKASCwAiMQCgEgsAIjEAoBILACIxAKAaCgA8Omy8vtVLAD4r9Z6WJs5hgIgEgsAIrEAIBILACKxACDyNRRAX85tTUuDeZ5fVp55EwuAvky11vPS4EEsLo6hAIjEAoBILACIxAKASCwAiOqjYXsz/tq2fQHgp/j4WktWLxL06SxAX7Zf65ta6/vaQ46hAIjEAoBILACIxAKAKL3gfisAdO8fbG5EZWQ12DUAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../assets/Images/bigbtn.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: N27-italic;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

body{
    overflow-x: hidden;
}

/* @font-face {
    font-family: PP-Nuebit;
    src: url("../../../assets/Fonts/PPNeueBit-Bold.otf");
} */

h1{
    font-weight: normal;
}

h2{
    font-weight: normal;
}
h3{
    font-weight: normal;
}

@font-face {
    font-family: N27;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});}

.mainframe{

    display: flex;
    flex-direction: column;
    
    margin-bottom: 0;
    padding: 15% 21%;
    align-items: flex-start;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 100% 100%;
}

.mainframe .mf1{
    font-family: N27-italic;
    font-style: italic;
    font-size: 1.4em;
}

.mainframe .mf1 h3{
    margin: 0;
}

.mainframe .mf2{
    font-family: PP-Nuebit;
    /* width: 100%; */
    position: relative;
    top:0;
   
}

.o-image{
    width: 3.8vw;
}

.mainframe .mf2 p{
    font-size: 12.2vw;
    width: 100%;
    margin: 0;
}

.mainframe .mf2 h1 img{
    height: 4.5vw;
}

.mainframe .mf3 {
    font-family: N27-italic;
    font-size: 21px;
    width: 380px;
    text-align: left ;
    align-self: flex-end;
    margin: 0;
    position: relative;
    top:0;
}

.mainframe .mf3 h3{
    margin: 0;
}

/* .blinking {
    animation: blinking 1s infinite;
  }
  
  @keyframes blinking {
    0%, 49% {
      opacity: 1;
    }
    50%, 100% {
      opacity: 0;
    }
  } */
.typewriter {
  overflow: hidden; /* Hide overflow to create the typewriter effect */
  white-space: nowrap; /* Prevent line breaks */
  animation: typewriter 2s steps(30) infinite;
}

@keyframes typewriter {
  from {
    width: 0;
  }
}

  
  

.mainframe .mf4{
        display: none;
        padding: 12px;
        flex-direction: row;
        justify-content: space-around;
        width: 145px;
        height: 28px;
        color: #ffffff;
        text-align: left;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
    
}

.mainframe .mf4 h3{
    font-family: PP-Nuebit;
    margin: 8px;
    color: white;
    font-weight: 100;
    font-size: 25px;
}

.frame2{
    font-family: N27;
    font-size: 39px;
    line-height: 80px;
    font-style: italic;
    text-align: left;
    margin: 3vw;
    padding: 11vw;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: 100%;
    
}

.frame3{
    
    height: auto;
    margin-bottom: 3vh;
}

.frame3 h1{
    position: relative; 
    left: 3%; 
    font-family: 'PP-NueBit';
font-style: normal;
/* font-weight: 700; */
font-size: 160px;
line-height: 136px;
/* margin: 0; */
margin-bottom: 80px;
margin-top: 120px;
text-align: left;

}
.frame4{
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-around;
    align-items: center;
    
}

.frame4 .f4-text{
    width: auto;
}

.frame4 .f4-text h1{
    text-align: left;
    font-family: 'PP-NueBit';
    font-style: normal;
/* font-weight: 700; */
    font-size: 13.8vw;
    line-height: 140px;
    margin: 0;
}

.frame4 .f4-text p{
    /* margin: 0px 20px; */
    font-family: 'N27';
    font-style: italic;
    font-weight: 600;
    font-size: 3.125vw;
    line-height: 30px;
    text-align: left;
    width: auto;
    padding: 4px 0;
}
@media only screen and (max-width: 1400px){
    .frame4 .f4-text h1{
        line-height: 100px;
    }
}

.frame4 .f4-arrow{
    /* position: relative;
    top: 8vh; */
    /* font-family: 'PP-NueBit';
    font-size: 200px; */
    align-self: flex-end;
    
}

.frame4 .f4-arrow img {
    height: 115px;
    width: 148px;
}



.frame5{
    position: relative;
    /* left: 7%; */
    height: 82vh;
}


.faq{
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
    margin: 100px 0;
}

.faq .faq-title{
    font-family:  'PP-Nuebit';
    font-size: 100px;
    margin: 40px;
}


.frame6{
    align-self: center;
    display: flex;
    flex-direction: row;
    /* width: 90%; */
    align-items: center;
    justify-content: center;
    height: 1000px;
    margin-bottom: 20vh;
}

.frame6 .f6-left {
    display: flex;
    flex-direction: column;
    height: 72%;
    padding: 0% 1%;
    justify-content: flex-start;
    color: #ffffff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 40%;
    margin-right: 3.5%;
    align-items: center;
    min-width: 420px;
}

.frame6 .f6-left .f6-left-title {
    /* width: 90%; */
    height: 20%;
    font-family: 'PP-Nuebit';
    font-style: normal;
    /* font-weight: 700; */
    font-size: 70px;
    line-height: 59px;
    text-align: center;
    margin: 0;
    margin-top: 24%;
}

.frame6 .f6-left .f6-left-para {
    /* margin: 0; */
    width: 80%;
    height: 22%;
    font-family: 'N27';
    font-style: normal;
    font-weight: 400;
    font-size: 26px;
    line-height: 30px;
    /* margin-bottom: 10%; */
}

.contact {
    width: 48%;
    height: 6%;
    color: #000000;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    font-family: 'N27';
    font-style: italic;
    padding: 12px 10px 10px 10px;
    font-weight: 700;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.contact:hover{
    cursor: pointer;
}


.frame6 .f6-button{
    margin: 3.2%;
}

.frame6 .f6-right {
    display: flex;
    flex-direction: column;
    height: 72%;
    justify-content: flex-start;
    color: #151515;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 0% 1%;
    width: 40%;
    align-items: center;
    min-width: 420px;
}



.frame6 .f6-right .f6-right-title {
    /* width: 80%; */
    height: 20%;
    font-family: 'PP-Nuebit';
    font-style: normal;
    /* font-weight: 700; */
    font-size: 75px;
    line-height: 59px;
    text-align: center;
    margin: 0;
    margin-top: 24%;
}

.frame6 .f6-right .f6-right-para {
    /* margin: 0; */
    width: 80%;
    height: 22%;
    font-family: 'N27';
    font-style: normal;
    font-weight: 400;
    font-size: 26px;
    line-height: 30px;
    /* margin-bottom: 10%; */
}

.f6-join{
    width: 49%;
    height: 6%;
    color: #ffffff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    font-family: 'N27';
font-style: italic;
padding: 10px;
font-weight: 700;
font-size: 20px;
line-height: 29px;
margin-bottom: 25px;
display: flex;
align-items: flex-start;
justify-content: center;
cursor: pointer;

}

.f6-view{
    border: 1pt solid black;
    width: 50%;
    height: 7%;
    color: #000000;
    background: #ffffff;
    font-family: 'N27';
    padding: 5px 0px;
font-style: italic;
cursor: pointer;
font-weight: 700;
font-size: 1.2vw;
line-height: 49px;

}

.line{
    margin: 51px 6%;
    width: 87%;
    height: 1.5px;
    background: #000000;
}

.footer{
    display: flex;
    flex-direction: column;
    padding: 3% 5%;
    margin: 0;
    /* border-top: 1pt solid black; */

}

.footer .footer-top{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    text-align: left;
    padding-top: 3%;
    /* padding: 3%; */
    border-top: 2pt solid black;

}

.footer .footer-top .footer-top-left{
    text-align: left;
    width: 30%;
}

.footer-top h1{
    font-family: PP-Nuebit;
}

.footer-top p{
    font-family: N27;
    font-style: italic;
    font-size: 20px;
}

.footer-top a{
    font-size: 20px;
    font-family: N27-italic;
    font-style: italic;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    text-decoration: none;
    color: #000000;
    word-spacing: 10px;
}

.footer .footer-top .footer-top-right{
    display: flex;
    flex-direction: column;
    position: relative;
    top: 0px;
}

.footer .footer-top .footer-top-right h1{
    margin: 0;
    font-size: 80px;
}

.footer .footer-top .footer-top-right .footer-initiative{
    font-size: 18px;
    height: 60px;
    width: 344px;
    font-family: N27;
    font-style: italic;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-color: transparent;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    text-align: center;
    color: white;
    cursor: pointer;
    
}

.footer .footer-top .footer-top-right .footer-initiative p{
    font-size: 16px;
    margin-top: 23px;
}

.footer .footer-top .footer-top-mid{
    display: flex;
    width: 35%;
    justify-content: space-around;
}

.footer .footer-mid{
    display: flex;
    height: 25%;
    justify-content: center;
    margin: 60px 0px;
    
}

.footer .footer-mid .mid-container{
    width: 50%;
    display: flex;
    background: black;
    color: white;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    min-width: 730px;
}

.footer .footer-mid .mid-container h3{
    font-family: 'N27';
font-style: italic;
font-weight: 500;
font-size: 16px;
line-height: 24px;
margin-right: 20px;
}

.footer .footer-mid .mid-container .email{
    background-color: white;
    display: flex;
    justify-content: space-between;
    width: 50%;
    align-items: center;
    height: 70%;
    padding-left: 15px;
    font-family: N27;
    font-size: 16px;
}

.footer .footer-mid .mid-container .email .ip-box:focus-visible {
    outline: none;
}

.footer .footer-mid .mid-container .email .ip-box{
    height: 80%;
    width: 70%;
    border: none;
    background: transparent;
    
}



.footer .footer-mid .mid-container .submit-button{
    align-self: center;
    height: 60%;
    border: none;
    border-left: 1pt solid black;
    font-family: 'N27';
    font-weight: 500;
    font-size: 15px;
    background: transparent;
    cursor: pointer;

}

.footer .footer-bottom{
    margin: 35px 0px;
    align-self: center;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;  
}

.footer .footer-bottom div{
    display: flex;
    flex-direction: row;
}

.footer .footer-bottom p{
    font-family: N27;
    margin-right: 10px;
}
    

hr{
        /* transform: rotate(90deg); */
        background-color: #000000;
    height: 1.5px;
    position: relative;
        top: -10%;
        z-index: -1;
        width: 130%;
  
  }

  .loading {
    animation: sk-scaleout 1.0s infinite ease-in-out;
    background-color: black;
    border-radius: 100%;
    height: 6em;
    width: 6em;
  }
  
  .spin-container {
    align-items: center;
    display: flex;
    height: 100vh;
    justify-content: center;
    width: 100vw;
  }
  
  @keyframes sk-scaleout {
    0% {
      transform: scale(0);
    }
    100% {
      -webkit-transform: scale(1.0);
      opacity: 0;
      transform: scale(1.0);
    }
  }

@keyframes marquee {
    from { transform: translateX(0); }
    to { transform: translateX(-50%); }
  }



  @media only screen and (min-width: 1600px){
    .frame6 .f6-right {
        height: 84%;
    }

    .frame6 .f6-left{
        height: 84%;
    }
    .frame6 .f6-right .f6-right-title{
        font-size: 90px;
    }
    .frame6 .f6-left .f6-left-title {
        font-size: 85px;
    }

    .f6-join {
        font-size: 25px;
    }
    .f6-view{
        height: auto;
    }
}


@media only screen and (max-width: 1268px){
    .frame6 .f6-left .f6-left-para {
        font-size: 23px;
        line-height: 25px;
    }
    .frame6 .f6-right .f6-right-para {
        font-size: 23px;
        line-height: 25px;
    }
    .frame6 .f6-left .f6-left-title {
        font-size: 65px;
        line-height: 50px;
    }
    .frame6 .f6-right .f6-right-title{
        font-size: 65px;
        line-height: 50px;
    }
}


  

  @media only screen and (max-width: 600px){
    .mainframe {
        background-image: none;
        width: 100%;
        margin: 3%;
        
        margin-bottom: 0;
        padding: 3%;
        align-items: flex-start;
        padding-top: 28vh;
    }
    .mainframe .mf1{
        font-size: 1.2em;
    }

    .mainframe .mf2 {
        top:0;
    }

    .mainframe .mf2 p{
        font-size: 20vw;
    }

    .mainframe .mf2 p img {
        height: 7.5vw;
    }
    
    .o-image{
        width: auto ;
    }


    .mainframe .mf3 {
        font-size: 17px;
    width: 100%;
    text-align: left;
    align-self: flex-start;
    }

    .mainframe .mf4{
        display: flex;
    }

    .frame2 {
    background-image: none;
    font-family: N27;
    font-size: 21px;
    line-height: 35px;
    font-style: italic;
    text-align: left;
    margin: 0%;
    padding: 3vh;
    margin-top: 30vh;
    margin-bottom: 15vh;
}

    #why{
    padding-top: 12vh;
    }

    .frame3 h1{
        font-size: 45px;
    line-height: 42px;
    margin-bottom: 0;
    }

    .frame4{
        background-image: none;
        display: block;
    }

    .frame4 .f4-text {
        width: auto;
        margin-left: 15px;
        margin-right: 0;
        text-align: left;
    }

    .frame4 .f4-text h1 {
        text-align: left;
        font-family: 'PP-NueBit';
        font-style: normal;
        /* font-weight: 700; */
        font-size: 80px;
        line-height: 0.8em;
        text-align: left;
        margin: 0;
    }

    .frame4 .f4-text p {
        font-family: 'N27';
        font-style: italic;
        font-weight: 600;
        font-size: 24px;
        line-height: 30px;
        text-align: left;
        width: auto;
    }
    #roadmap{
        padding-top: 10vh;
    }
    

    .frame4 .f4-arrow {
        position: relative;
        /* top: 8vh; */
        left: 71vw;
        width: 30%;
        text-align: right;
        align-self: flex-end;
        transform: rotate(90deg);
  }

  .frame4 .f4-arrow img{
    height: 65px;
    width: 75px;
  }

  .frame6{
    width: auto;
    height: auto;
    flex-direction: column;
    padding-top:8vh;
  }

  .frame6 .f6-left {
    width: auto;
    margin: 1.5%;
    min-width: 0;
    
}

.frame6 .f6-left .f6-left-title {
    width: 90%;
    font-size: 40px;
    line-height: 29px;
    margin-block-start: 2em;
    margin-block-end: 0.53em;
    max-width: 330px;
}
.frame6 .f6-left .f6-left-para {
    margin: 1em;
    font-size: 18px;
    line-height: 19px;
    margin-bottom: 10%;
}
.contact{
    margin: 39px 0px;
}

.faq{
    margin: 50px 0;
}

.faq .faq-title{
    font-family:  'PP-Nuebit';
    font-size: 50px;
    margin: 20px;
}

.frame6 .f6-right{
    
    width: auto;
    margin: 1.5%;
    min-width: 0;
}

.contact{
    padding: 8px;
    width: 70%;
}

.frame6 .f6-join{
    width: 70%;
    padding: 5px;
}

.frame6 .f6-button {
    padding: 0;
    font-size: 13px;
    margin: 5px 0px;
}

.f6-view{
    width: 70%;
    font-size: 14px;
    margin-bottom: 40px;
    /* padding: 5px 0px; */
    line-height: 29px;
}

.frame6 .f6-right .f6-right-title{
    width: 90%;
    font-size: 40px;
    line-height: 29px;
    margin-block-start: 2em;
    margin-block-end: 0.53em;
}
.frame6 .f6-right .f6-right-para{
    margin: 1em;
    font-size: 18px;
    line-height: 19px;
    margin-bottom: 10%;
}

.footer  .footer-top .footer-top-right h1 {
    font-family: PP-Nuebit;
    font-size: 29px;
}

.footer .footer-top h1{
    font-size: 29px;
}
.footer-top a {
    font-size: 16px;
}

.footer-top p{
    font-size: 15px;
}

.footer .footer-top .footer-top-right .footer-initiative p {
    font-size: 12px;
    margin-top: 12px;
}

.footer .footer-top .footer-top-right {
    width: 100%;
    font-size: 16px;
    align-items: center;
    margin-bottom: 20px;
    top: 0px;
}
.footer .footer-top .footer-top-right .footer-initiative {
    font-size: 18px;
    height: 38px;
    width: 166px;
}

.footer .footer-top {
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-evenly;
    align-items: flex-start;
    text-align: left;
}

.footer-top-left{
    display: none;
}

.footer .footer-mid .mid-container {
    width: auto;
    display: flex;
    background: transparent;
    color: black;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    min-width: 0;
}

/* .footer .footer-mid .mid-container .email {
    align-self: center;
    height: 36px;
    width: 83%;
    border: none;
    box-shadow: #000000;
} */

.footer .footer-top .footer-top-mid{
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
   
}

.footer .footer-mid .mid-container .email{
    flex-direction: column;
    background-color: transparent;
    width: 80%;
}

.footer .footer-mid .mid-container .email .ip-box {
    height: 80%;
    border-radius: 0;
    border: 1pt solid black;
    width: 100%;
    text-align: center;
    font-family: N27;
    height: 30%;
    font-size: 16px;
}


.footer .footer-mid .mid-container h3 {
    width: 55%;
    font-size: 18px;
    font-weight: bold;
}
 
.footer .footer-mid .mid-container .submit-button {
    align-self: center;
    height: auto;
    margin-left: 0;
    margin: 10px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 100% 100%;
    background-color: transparent;
    border-radius: 0;
    width: 180px;
    height: 60px;
    border: none;
    color: white;
}

.line{
    margin: 50px 30px;
}

}`, "",{"version":3,"sources":["webpack://./src/components/Pages/HomePage/Homepage.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,4CAAuD;AAC3D;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;GAGG;;AAEH;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,4CAAiD,CAAC;;AAEtD;;IAEI,aAAa;IACb,sBAAsB;;IAEtB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,yDAA6D;IAC7D,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,KAAK;;AAET;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,SAAS;IACT,kBAAkB;IAClB,KAAK;AACT;;AAEA;IACI,SAAS;AACb;;AAEA;;;;;;;;;;;KAWK;AACL;EACE,gBAAgB,EAAE,kDAAkD;EACpE,mBAAmB,EAAE,wBAAwB;EAC7C,2CAA2C;AAC7C;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;;;;AAKA;QACQ,aAAa;QACb,aAAa;QACb,mBAAmB;QACnB,6BAA6B;QAC7B,YAAY;QACZ,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,yDAA4D;QAC5D,4BAA4B;QAC5B,0BAA0B;QAC1B,eAAe;;AAEvB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,yDAA6D;IAC7D,qBAAqB;;AAEzB;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;AAC5B,kBAAkB;AAClB,sBAAsB;AACtB,gBAAgB;AAChB,kBAAkB;AAClB,eAAe;AACf,mBAAmB;AACnB,iBAAiB;AACjB,gBAAgB;;AAEhB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;AACtB,sBAAsB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;eACW;IACX;uBACmB;IACnB,oBAAoB;;AAExB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;;;AAIA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,2BAA2B;IAC3B,cAAc;IACd,yDAAiyN;IACjyN,0BAA0B;IAC1B,4BAA4B;IAC5B,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,UAAU;IACV,cAAc;IACd,yDAAyzB;IACzzB,0BAA0B;IAC1B,4BAA4B;IAC5B,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,2BAA2B;IAC3B,cAAc;IACd,yDAAiuN;IACjuN,0BAA0B;IAC1B,4BAA4B;IAC5B,cAAc;IACd,UAAU;IACV,mBAAmB;IACnB,gBAAgB;AACpB;;;;AAIA;IACI,gBAAgB;IAChB,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,UAAU;IACV,cAAc;IACd,yDAA0D;IAC1D,4BAA4B;IAC5B,0BAA0B;IAC1B,kBAAkB;AACtB,kBAAkB;AAClB,aAAa;AACb,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,mBAAmB;AACnB,aAAa;AACb,uBAAuB;AACvB,uBAAuB;AACvB,eAAe;;AAEf;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB,kBAAkB;AAClB,eAAe;AACf,gBAAgB;AAChB,gBAAgB;AAChB,iBAAiB;;AAEjB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,SAAS;IACT,iCAAiC;;AAErC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;;AAE/B;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,qBAAqB;IACrB,wBAAwB;IACxB,sBAAsB;IACtB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,yDAA0D;IAC1D,6BAA6B;IAC7B,4BAA4B;IAC5B,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,eAAe;;AAEnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,gBAAgB;;AAEpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,kBAAkB;AAClB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,uBAAuB;;AAE3B;;;;AAIA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,eAAe;;AAEnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA;QACQ,8BAA8B;QAC9B,yBAAyB;IAC7B,aAAa;IACb,kBAAkB;QACd,SAAS;QACT,WAAW;QACX,WAAW;;EAEjB;;EAEA;IAEE,gDAAgD;IAChD,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE;MAEE,mBAAmB;IACrB;IACA;MACE,6BAA6B;MAC7B,UAAU;MACV,qBAAqB;IACvB;EACF;;AAEF;IACI,OAAO,wBAAwB,EAAE;IACjC,KAAK,2BAA2B,EAAE;EACpC;;;;EAIA;IACE;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;AACJ;;;AAGA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;;;;EAKE;IACE;QACI,sBAAsB;QACtB,WAAW;QACX,UAAU;;QAEV,gBAAgB;QAChB,WAAW;QACX,uBAAuB;QACvB,iBAAiB;IACrB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,KAAK;IACT;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;;IAGA;QACI,eAAe;IACnB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;IACA,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;IAEI;IACA,iBAAiB;IACjB;;IAEA;QACI,eAAe;IACnB,iBAAiB;IACjB,gBAAgB;IAChB;;IAEA;QACI,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,wBAAwB;QACxB,kBAAkB;QAClB,sBAAsB;QACtB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,iBAAiB;IACrB;;;IAGA;QACI,kBAAkB;QAClB,cAAc;QACd,UAAU;QACV,UAAU;QACV,iBAAiB;QACjB,oBAAoB;QACpB,wBAAwB;EAC9B;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;;AAEhB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,wBAAwB;IACxB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;;;;;GAMG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,6BAA6B;;AAEjC;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;;AAGA;IACI,UAAU;IACV,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,yDAA4D;IAC5D,0BAA0B;IAC1B,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA","sourcesContent":["@font-face {\n    font-family: N27-italic;\n    src: url(\"../../../assets/Fonts/N27-RegularItalic.otf\");\n}\n\nbody{\n    overflow-x: hidden;\n}\n\n/* @font-face {\n    font-family: PP-Nuebit;\n    src: url(\"../../../assets/Fonts/PPNeueBit-Bold.otf\");\n} */\n\nh1{\n    font-weight: normal;\n}\n\nh2{\n    font-weight: normal;\n}\nh3{\n    font-weight: normal;\n}\n\n@font-face {\n    font-family: N27;\n    src: url(\"../../../assets/Fonts/N27-Regular.otf\");}\n\n.mainframe{\n\n    display: flex;\n    flex-direction: column;\n    \n    margin-bottom: 0;\n    padding: 15% 21%;\n    align-items: flex-start;\n    background-image: url(\"../../../assets/Images/frame1-bg.png\");\n    background-size: 100% 100%;\n}\n\n.mainframe .mf1{\n    font-family: N27-italic;\n    font-style: italic;\n    font-size: 1.4em;\n}\n\n.mainframe .mf1 h3{\n    margin: 0;\n}\n\n.mainframe .mf2{\n    font-family: PP-Nuebit;\n    /* width: 100%; */\n    position: relative;\n    top:0;\n   \n}\n\n.o-image{\n    width: 3.8vw;\n}\n\n.mainframe .mf2 p{\n    font-size: 12.2vw;\n    width: 100%;\n    margin: 0;\n}\n\n.mainframe .mf2 h1 img{\n    height: 4.5vw;\n}\n\n.mainframe .mf3 {\n    font-family: N27-italic;\n    font-size: 21px;\n    width: 380px;\n    text-align: left ;\n    align-self: flex-end;\n    margin: 0;\n    position: relative;\n    top:0;\n}\n\n.mainframe .mf3 h3{\n    margin: 0;\n}\n\n/* .blinking {\n    animation: blinking 1s infinite;\n  }\n  \n  @keyframes blinking {\n    0%, 49% {\n      opacity: 1;\n    }\n    50%, 100% {\n      opacity: 0;\n    }\n  } */\n.typewriter {\n  overflow: hidden; /* Hide overflow to create the typewriter effect */\n  white-space: nowrap; /* Prevent line breaks */\n  animation: typewriter 2s steps(30) infinite;\n}\n\n@keyframes typewriter {\n  from {\n    width: 0;\n  }\n}\n\n  \n  \n\n.mainframe .mf4{\n        display: none;\n        padding: 12px;\n        flex-direction: row;\n        justify-content: space-around;\n        width: 145px;\n        height: 28px;\n        color: #ffffff;\n        text-align: left;\n        background-image: url(\"../../../assets/Images/buttonbg.png\");\n        background-repeat: no-repeat;\n        background-size: 100% 100%;\n        cursor: pointer;\n    \n}\n\n.mainframe .mf4 h3{\n    font-family: PP-Nuebit;\n    margin: 8px;\n    color: white;\n    font-weight: 100;\n    font-size: 25px;\n}\n\n.frame2{\n    font-family: N27;\n    font-size: 39px;\n    line-height: 80px;\n    font-style: italic;\n    text-align: left;\n    margin: 3vw;\n    padding: 11vw;\n    background-image: url(\"../../../assets/Images/frame2-bg.png\");\n    background-size: 100%;\n    \n}\n\n.frame3{\n    \n    height: auto;\n    margin-bottom: 3vh;\n}\n\n.frame3 h1{\n    position: relative; \n    left: 3%; \n    font-family: 'PP-NueBit';\nfont-style: normal;\n/* font-weight: 700; */\nfont-size: 160px;\nline-height: 136px;\n/* margin: 0; */\nmargin-bottom: 80px;\nmargin-top: 120px;\ntext-align: left;\n\n}\n.frame4{\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    justify-content: space-around;\n    align-items: center;\n    \n}\n\n.frame4 .f4-text{\n    width: auto;\n}\n\n.frame4 .f4-text h1{\n    text-align: left;\n    font-family: 'PP-NueBit';\n    font-style: normal;\n/* font-weight: 700; */\n    font-size: 13.8vw;\n    line-height: 140px;\n    margin: 0;\n}\n\n.frame4 .f4-text p{\n    /* margin: 0px 20px; */\n    font-family: 'N27';\n    font-style: italic;\n    font-weight: 600;\n    font-size: 3.125vw;\n    line-height: 30px;\n    text-align: left;\n    width: auto;\n    padding: 4px 0;\n}\n@media only screen and (max-width: 1400px){\n    .frame4 .f4-text h1{\n        line-height: 100px;\n    }\n}\n\n.frame4 .f4-arrow{\n    /* position: relative;\n    top: 8vh; */\n    /* font-family: 'PP-NueBit';\n    font-size: 200px; */\n    align-self: flex-end;\n    \n}\n\n.frame4 .f4-arrow img {\n    height: 115px;\n    width: 148px;\n}\n\n\n\n.frame5{\n    position: relative;\n    /* left: 7%; */\n    height: 82vh;\n}\n\n\n.faq{\n    display: flex;\n    flex-direction: column;\n    align-content: center;\n    justify-content: center;\n    align-items: center;\n    margin: 100px 0;\n}\n\n.faq .faq-title{\n    font-family:  'PP-Nuebit';\n    font-size: 100px;\n    margin: 40px;\n}\n\n\n.frame6{\n    align-self: center;\n    display: flex;\n    flex-direction: row;\n    /* width: 90%; */\n    align-items: center;\n    justify-content: center;\n    height: 1000px;\n    margin-bottom: 20vh;\n}\n\n.frame6 .f6-left {\n    display: flex;\n    flex-direction: column;\n    height: 72%;\n    padding: 0% 1%;\n    justify-content: flex-start;\n    color: #ffffff;\n    background-image: url(data:image/png;base64,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);\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    width: 40%;\n    margin-right: 3.5%;\n    align-items: center;\n    min-width: 420px;\n}\n\n.frame6 .f6-left .f6-left-title {\n    /* width: 90%; */\n    height: 20%;\n    font-family: 'PP-Nuebit';\n    font-style: normal;\n    /* font-weight: 700; */\n    font-size: 70px;\n    line-height: 59px;\n    text-align: center;\n    margin: 0;\n    margin-top: 24%;\n}\n\n.frame6 .f6-left .f6-left-para {\n    /* margin: 0; */\n    width: 80%;\n    height: 22%;\n    font-family: 'N27';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 26px;\n    line-height: 30px;\n    /* margin-bottom: 10%; */\n}\n\n.contact {\n    width: 48%;\n    height: 6%;\n    color: #000000;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYsAAABMCAYAAACcepszAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHdSURBVHgB7dyxbeMwGIZh8iD3btRf7eYygr1BSpc3lPt4k1gbOBtkABcZwICOuKSL5K8PnwcgCPiH6hemBNZtMwzDU1lwv9+vH00BoGvDZrN5bvvL4nAYDm27FAC69qsAQCAWAERiAUAkFgBEYgFAVMdxfJrn+XlpOE3Tn91uty0A9OxaH01bRF7bti8A9OziGAqASCwAiMQCgEgsAIjEAoBoGMfxb1m5SLDNDrfb7bA0m5sCQBf8swAgEgsAIrEAIBILACKxACAa5nl+b+u8NDydTvvj8fi7ANA1FwkCkLhIEIBMLACIxAKASCwAiMQCgEgsAIjEAoBILACIxAKASCwAiMQCgEgsAIjEAoBILACIxAKASCwAiMQCgEgsAIjEAoBILACIxAKASCwAiMQCgEgsAIjEAoBILACIxAKASCwAiMQCgEgsAIjEAoBILACIxAKAaCgA8Omy8vtVLAD4r9Z6WJs5hgIgEgsAIrEAIBILACKxACDyNRRAX85tTUuDeZ5fVp55EwuAvky11vPS4EEsLo6hAIjEAoBILACIxAKASCwAiOqjYXsz/tq2fQHgp/j4WktWLxL06SxAX7Zf65ta6/vaQ46hAIjEAoBILACIxAKAKL3gfisAdO8fbG5EZWQ12DUAAAAASUVORK5CYII=);\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    font-family: 'N27';\n    font-style: italic;\n    padding: 12px 10px 10px 10px;\n    font-weight: 700;\n    font-size: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.contact:hover{\n    cursor: pointer;\n}\n\n\n.frame6 .f6-button{\n    margin: 3.2%;\n}\n\n.frame6 .f6-right {\n    display: flex;\n    flex-direction: column;\n    height: 72%;\n    justify-content: flex-start;\n    color: #151515;\n    background-image: url(data:image/png;base64,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);\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    padding: 0% 1%;\n    width: 40%;\n    align-items: center;\n    min-width: 420px;\n}\n\n\n\n.frame6 .f6-right .f6-right-title {\n    /* width: 80%; */\n    height: 20%;\n    font-family: 'PP-Nuebit';\n    font-style: normal;\n    /* font-weight: 700; */\n    font-size: 75px;\n    line-height: 59px;\n    text-align: center;\n    margin: 0;\n    margin-top: 24%;\n}\n\n.frame6 .f6-right .f6-right-para {\n    /* margin: 0; */\n    width: 80%;\n    height: 22%;\n    font-family: 'N27';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 26px;\n    line-height: 30px;\n    /* margin-bottom: 10%; */\n}\n\n.f6-join{\n    width: 49%;\n    height: 6%;\n    color: #ffffff;\n    background-image: url(\"../../../assets/Images/bigbtn.png\");\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    font-family: 'N27';\nfont-style: italic;\npadding: 10px;\nfont-weight: 700;\nfont-size: 20px;\nline-height: 29px;\nmargin-bottom: 25px;\ndisplay: flex;\nalign-items: flex-start;\njustify-content: center;\ncursor: pointer;\n\n}\n\n.f6-view{\n    border: 1pt solid black;\n    width: 50%;\n    height: 7%;\n    color: #000000;\n    background: #ffffff;\n    font-family: 'N27';\n    padding: 5px 0px;\nfont-style: italic;\ncursor: pointer;\nfont-weight: 700;\nfont-size: 1.2vw;\nline-height: 49px;\n\n}\n\n.line{\n    margin: 51px 6%;\n    width: 87%;\n    height: 1.5px;\n    background: #000000;\n}\n\n.footer{\n    display: flex;\n    flex-direction: column;\n    padding: 3% 5%;\n    margin: 0;\n    /* border-top: 1pt solid black; */\n\n}\n\n.footer .footer-top{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n    text-align: left;\n    padding-top: 3%;\n    /* padding: 3%; */\n    border-top: 2pt solid black;\n\n}\n\n.footer .footer-top .footer-top-left{\n    text-align: left;\n    width: 30%;\n}\n\n.footer-top h1{\n    font-family: PP-Nuebit;\n}\n\n.footer-top p{\n    font-family: N27;\n    font-style: italic;\n    font-size: 20px;\n}\n\n.footer-top a{\n    font-size: 20px;\n    font-family: N27-italic;\n    font-style: italic;\n    display: block;\n    margin-block-start: 1em;\n    margin-block-end: 1em;\n    margin-inline-start: 0px;\n    margin-inline-end: 0px;\n    text-decoration: none;\n    color: #000000;\n    word-spacing: 10px;\n}\n\n.footer .footer-top .footer-top-right{\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    top: 0px;\n}\n\n.footer .footer-top .footer-top-right h1{\n    margin: 0;\n    font-size: 80px;\n}\n\n.footer .footer-top .footer-top-right .footer-initiative{\n    font-size: 18px;\n    height: 60px;\n    width: 344px;\n    font-family: N27;\n    font-style: italic;\n    background-image: url(\"../../../assets/Images/bigbtn.png\");\n    background-color: transparent;\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    text-align: center;\n    color: white;\n    cursor: pointer;\n    \n}\n\n.footer .footer-top .footer-top-right .footer-initiative p{\n    font-size: 16px;\n    margin-top: 23px;\n}\n\n.footer .footer-top .footer-top-mid{\n    display: flex;\n    width: 35%;\n    justify-content: space-around;\n}\n\n.footer .footer-mid{\n    display: flex;\n    height: 25%;\n    justify-content: center;\n    margin: 60px 0px;\n    \n}\n\n.footer .footer-mid .mid-container{\n    width: 50%;\n    display: flex;\n    background: black;\n    color: white;\n    flex-direction: row;\n    justify-content: space-around;\n    align-items: center;\n    min-width: 730px;\n}\n\n.footer .footer-mid .mid-container h3{\n    font-family: 'N27';\nfont-style: italic;\nfont-weight: 500;\nfont-size: 16px;\nline-height: 24px;\nmargin-right: 20px;\n}\n\n.footer .footer-mid .mid-container .email{\n    background-color: white;\n    display: flex;\n    justify-content: space-between;\n    width: 50%;\n    align-items: center;\n    height: 70%;\n    padding-left: 15px;\n    font-family: N27;\n    font-size: 16px;\n}\n\n.footer .footer-mid .mid-container .email .ip-box:focus-visible {\n    outline: none;\n}\n\n.footer .footer-mid .mid-container .email .ip-box{\n    height: 80%;\n    width: 70%;\n    border: none;\n    background: transparent;\n    \n}\n\n\n\n.footer .footer-mid .mid-container .submit-button{\n    align-self: center;\n    height: 60%;\n    border: none;\n    border-left: 1pt solid black;\n    font-family: 'N27';\n    font-weight: 500;\n    font-size: 15px;\n    background: transparent;\n    cursor: pointer;\n\n}\n\n.footer .footer-bottom{\n    margin: 35px 0px;\n    align-self: center;\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;  \n}\n\n.footer .footer-bottom div{\n    display: flex;\n    flex-direction: row;\n}\n\n.footer .footer-bottom p{\n    font-family: N27;\n    margin-right: 10px;\n}\n    \n\nhr{\n        /* transform: rotate(90deg); */\n        background-color: #000000;\n    height: 1.5px;\n    position: relative;\n        top: -10%;\n        z-index: -1;\n        width: 130%;\n  \n  }\n\n  .loading {\n    -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;\n    animation: sk-scaleout 1.0s infinite ease-in-out;\n    background-color: black;\n    border-radius: 100%;\n    height: 6em;\n    width: 6em;\n  }\n  \n  .spin-container {\n    align-items: center;\n    display: flex;\n    height: 100vh;\n    justify-content: center;\n    width: 100vw;\n  }\n  \n  @keyframes sk-scaleout {\n    0% {\n      -webkit-transform: scale(0);\n      transform: scale(0);\n    }\n    100% {\n      -webkit-transform: scale(1.0);\n      opacity: 0;\n      transform: scale(1.0);\n    }\n  }\n\n@keyframes marquee {\n    from { transform: translateX(0); }\n    to { transform: translateX(-50%); }\n  }\n\n\n\n  @media only screen and (min-width: 1600px){\n    .frame6 .f6-right {\n        height: 84%;\n    }\n\n    .frame6 .f6-left{\n        height: 84%;\n    }\n    .frame6 .f6-right .f6-right-title{\n        font-size: 90px;\n    }\n    .frame6 .f6-left .f6-left-title {\n        font-size: 85px;\n    }\n\n    .f6-join {\n        font-size: 25px;\n    }\n    .f6-view{\n        height: auto;\n    }\n}\n\n\n@media only screen and (max-width: 1268px){\n    .frame6 .f6-left .f6-left-para {\n        font-size: 23px;\n        line-height: 25px;\n    }\n    .frame6 .f6-right .f6-right-para {\n        font-size: 23px;\n        line-height: 25px;\n    }\n    .frame6 .f6-left .f6-left-title {\n        font-size: 65px;\n        line-height: 50px;\n    }\n    .frame6 .f6-right .f6-right-title{\n        font-size: 65px;\n        line-height: 50px;\n    }\n}\n\n\n  \n\n  @media only screen and (max-width: 600px){\n    .mainframe {\n        background-image: none;\n        width: 100%;\n        margin: 3%;\n        \n        margin-bottom: 0;\n        padding: 3%;\n        align-items: flex-start;\n        padding-top: 28vh;\n    }\n    .mainframe .mf1{\n        font-size: 1.2em;\n    }\n\n    .mainframe .mf2 {\n        top:0;\n    }\n\n    .mainframe .mf2 p{\n        font-size: 20vw;\n    }\n\n    .mainframe .mf2 p img {\n        height: 7.5vw;\n    }\n    \n    .o-image{\n        width: auto ;\n    }\n\n\n    .mainframe .mf3 {\n        font-size: 17px;\n    width: 100%;\n    text-align: left;\n    align-self: flex-start;\n    }\n\n    .mainframe .mf4{\n        display: flex;\n    }\n\n    .frame2 {\n    background-image: none;\n    font-family: N27;\n    font-size: 21px;\n    line-height: 35px;\n    font-style: italic;\n    text-align: left;\n    margin: 0%;\n    padding: 3vh;\n    margin-top: 30vh;\n    margin-bottom: 15vh;\n}\n\n    #why{\n    padding-top: 12vh;\n    }\n\n    .frame3 h1{\n        font-size: 45px;\n    line-height: 42px;\n    margin-bottom: 0;\n    }\n\n    .frame4{\n        background-image: none;\n        display: block;\n    }\n\n    .frame4 .f4-text {\n        width: auto;\n        margin-left: 15px;\n        margin-right: 0;\n        text-align: left;\n    }\n\n    .frame4 .f4-text h1 {\n        text-align: left;\n        font-family: 'PP-NueBit';\n        font-style: normal;\n        /* font-weight: 700; */\n        font-size: 80px;\n        line-height: 0.8em;\n        text-align: left;\n        margin: 0;\n    }\n\n    .frame4 .f4-text p {\n        font-family: 'N27';\n        font-style: italic;\n        font-weight: 600;\n        font-size: 24px;\n        line-height: 30px;\n        text-align: left;\n        width: auto;\n    }\n    #roadmap{\n        padding-top: 10vh;\n    }\n    \n\n    .frame4 .f4-arrow {\n        position: relative;\n        /* top: 8vh; */\n        left: 71vw;\n        width: 30%;\n        text-align: right;\n        align-self: flex-end;\n        transform: rotate(90deg);\n  }\n\n  .frame4 .f4-arrow img{\n    height: 65px;\n    width: 75px;\n  }\n\n  .frame6{\n    width: auto;\n    height: auto;\n    flex-direction: column;\n    padding-top:8vh;\n  }\n\n  .frame6 .f6-left {\n    width: auto;\n    margin: 1.5%;\n    min-width: 0;\n    \n}\n\n.frame6 .f6-left .f6-left-title {\n    width: 90%;\n    font-size: 40px;\n    line-height: 29px;\n    margin-block-start: 2em;\n    margin-block-end: 0.53em;\n    max-width: 330px;\n}\n.frame6 .f6-left .f6-left-para {\n    margin: 1em;\n    font-size: 18px;\n    line-height: 19px;\n    margin-bottom: 10%;\n}\n.contact{\n    margin: 39px 0px;\n}\n\n.faq{\n    margin: 50px 0;\n}\n\n.faq .faq-title{\n    font-family:  'PP-Nuebit';\n    font-size: 50px;\n    margin: 20px;\n}\n\n.frame6 .f6-right{\n    \n    width: auto;\n    margin: 1.5%;\n    min-width: 0;\n}\n\n.contact{\n    padding: 8px;\n    width: 70%;\n}\n\n.frame6 .f6-join{\n    width: 70%;\n    padding: 5px;\n}\n\n.frame6 .f6-button {\n    padding: 0;\n    font-size: 13px;\n    margin: 5px 0px;\n}\n\n.f6-view{\n    width: 70%;\n    font-size: 14px;\n    margin-bottom: 40px;\n    /* padding: 5px 0px; */\n    line-height: 29px;\n}\n\n.frame6 .f6-right .f6-right-title{\n    width: 90%;\n    font-size: 40px;\n    line-height: 29px;\n    margin-block-start: 2em;\n    margin-block-end: 0.53em;\n}\n.frame6 .f6-right .f6-right-para{\n    margin: 1em;\n    font-size: 18px;\n    line-height: 19px;\n    margin-bottom: 10%;\n}\n\n.footer  .footer-top .footer-top-right h1 {\n    font-family: PP-Nuebit;\n    font-size: 29px;\n}\n\n.footer .footer-top h1{\n    font-size: 29px;\n}\n.footer-top a {\n    font-size: 16px;\n}\n\n.footer-top p{\n    font-size: 15px;\n}\n\n.footer .footer-top .footer-top-right .footer-initiative p {\n    font-size: 12px;\n    margin-top: 12px;\n}\n\n.footer .footer-top .footer-top-right {\n    width: 100%;\n    font-size: 16px;\n    align-items: center;\n    margin-bottom: 20px;\n    top: 0px;\n}\n.footer .footer-top .footer-top-right .footer-initiative {\n    font-size: 18px;\n    height: 38px;\n    width: 166px;\n}\n\n.footer .footer-top {\n    display: flex;\n    flex-direction: column-reverse;\n    justify-content: space-evenly;\n    align-items: flex-start;\n    text-align: left;\n}\n\n.footer-top-left{\n    display: none;\n}\n\n.footer .footer-mid .mid-container {\n    width: auto;\n    display: flex;\n    background: transparent;\n    color: black;\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: center;\n    min-width: 0;\n}\n\n/* .footer .footer-mid .mid-container .email {\n    align-self: center;\n    height: 36px;\n    width: 83%;\n    border: none;\n    box-shadow: #000000;\n} */\n\n.footer .footer-top .footer-top-mid{\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-around;\n   \n}\n\n.footer .footer-mid .mid-container .email{\n    flex-direction: column;\n    background-color: transparent;\n    width: 80%;\n}\n\n.footer .footer-mid .mid-container .email .ip-box {\n    height: 80%;\n    border-radius: 0;\n    border: 1pt solid black;\n    width: 100%;\n    text-align: center;\n    font-family: N27;\n    height: 30%;\n    font-size: 16px;\n}\n\n\n.footer .footer-mid .mid-container h3 {\n    width: 55%;\n    font-size: 18px;\n    font-weight: bold;\n}\n \n.footer .footer-mid .mid-container .submit-button {\n    align-self: center;\n    height: auto;\n    margin-left: 0;\n    margin: 10px;\n    background-image: url(\"../../../assets/Images/buttonbg.png\");\n    background-size: 100% 100%;\n    background-color: transparent;\n    border-radius: 0;\n    width: 180px;\n    height: 60px;\n    border: none;\n    color: white;\n}\n\n.line{\n    margin: 50px 30px;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
